module.exports = __webpack_public_path__ + "static/img/donut-question.8fc8d08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/donut-question.svg
// module id = j9Gl
// module chunks = 0